import {DateRange} from "react-day-picker";

import {DatePickerValidator} from "@/components/datePicker/subComponents/DatePickerPopoverSingleDateInput/DatePickerPopoverSingleDateInput.types.ts";

export const RangeEndInputValidator = (selected: DateRange): DatePickerValidator => ({
  validate: (value: string) => {
    if (!value) return true;
    const date = new Date(value);
    if (selected?.from && date < selected?.from) {
      console.warn("End date cannot be before start date");
      return false;
    }
    return true;
  },
  errorMessage: "End date cannot be before start date",
});

export const RangeStartInputValidator = (selected: DateRange): DatePickerValidator => ({
  validate: (value: string) => {
    if (!value) return true;
    const date = new Date(value);
    const range = selected;
    if (range?.to && date > range?.to) {
      console.warn("Start date cannot be after end date");
      return false;
    }
    return true;
  },
  errorMessage: "Start date cannot be after end date",
});
